









import {Component, Vue, Prop, Watch} from 'vue-property-decorator'

@Component
export default class KDrawer extends Vue {
  @Prop({default: false, type: Boolean}) open
  @Prop({default: 'btt', type: String}) direction: 'ltr' | 'rtl' | 'ttb' | 'btt'

  get transitionName() {
    return `k-drawer-${this.direction}`
  }

  @Watch('open', {immediate: true})
  __open(value) {
    const body = document.getElementsByTagName('body')
    if(value) {
      body[0].style.overflowY = 'hidden'
    } else {
      body[0].style.overflowY = 'auto'
    }
  }
}
